export const midMock = [
  {
    "id": "91f5e283-0cd2-45cf-a206-72ea4987de90",
    "documentNumber": "22NL000855169898D7",
    "documentType": "NT1",
    "shipmentId": null,
    "equipments": [
      {
        "id": "BMOU9255560",
        "type": "CN"
      }
    ],
    "terminal": "ZEELOG",
    "terminalMessageScenarioVersion": "V2",
    "sender": "VAREKAMPCOLD",
    "documentStatus": "SENT"
  },
  {
    "id": "3e9425ef-e2a7-4f9d-99b1-1634f526fa3b",
    "documentNumber": "22NL000510168D6C82",
    "documentType": "MRN",
    "shipmentId": null,
    "equipments": [
      {
        "id": "TLLU2729826",
        "type": "CN"
      }
    ],
    "terminal": "RST",
    "sender": "CMACGMRHN",
    "documentStatus": "ACCEPTED"
  }
]
